/** Johdannaisen option_state: 2 Open, 3 Exercised, 4 Expired, 5 Terminated, 6 Delete */
const OPTION_STATE_LABELS = {
  2: { key: "option_state_open", defaultFi: "Avoin" },
  3: { key: "option_state_exercised", defaultFi: "Toteutettu" },
  4: { key: "option_state_expired", defaultFi: "Erääntynyt" },
  5: { key: "option_state_terminated", defaultFi: "Terminoitu" },
  6: { key: "option_state_deleted", defaultFi: "Delete" },
};

const OPTION_STATE_BY_VALUE = {
  open: 2,
  exercised: 3,
  expired: 4,
  terminated: 5,
  delete: 6,
};

export const shouldShowOptionStateDate = (optionState, showStateDate = false) =>
  Boolean(showStateDate) || Number(optionState) > 2;

const resolveStateKey = (stateKey) => {
  if (stateKey == null || stateKey === "") return null;
  const asNumber = Number(stateKey);
  if (OPTION_STATE_LABELS[asNumber]) return asNumber;
  const fromValue = OPTION_STATE_BY_VALUE[String(stateKey).trim().toLowerCase()];
  return fromValue ?? null;
};

export const getOptionStateLabel = (t, stateKey) => {
  const resolved = resolveStateKey(stateKey);
  const entry = resolved != null ? OPTION_STATE_LABELS[resolved] : null;
  if (!entry) return "";
  return t(entry.key, entry.defaultFi);
};
